// 最新活动
import request from '@/utils/request'

//查询栏目产品绑定关系
export function queryChannelProductById(id) {
    return request.post('/front/content/queryChannelProductById?id=' + id)
}
//根据栏目ID查询栏目详情
export function queryChannelInfoByID(id) {
    return request.post('/front/content/queryChannelInfoByID?id=' + id)
}